function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-7.974)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 47.841,
  height: 31.894,
  fill: "#006"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0V3.566L42.492,31.894h5.349V28.328L5.349,0ZM47.841,0V3.566L5.349,31.894H0V28.328L42.492,0Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.934,0V31.894h7.973V0ZM0,10.631V21.262H47.841V10.631Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,12.757v6.379H47.841V12.757ZM21.528,0V31.894h4.784V0Z",
  fill: "#c00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,31.894,15.947,21.262h3.566L3.566,31.894ZM0,0,15.947,10.631H12.381L0,2.377ZM28.328,10.631,44.275,0h3.566L31.894,10.631ZM47.841,31.894,31.894,21.262H35.46l12.381,8.254Z",
  fill: "#c00"
})));

function SvgUnitedKingdom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/united-kingdom.b9d59587.svg";
export { ForwardRef as ReactComponent };